import { Stack } from '@mui/material';
import { PermissionSet } from '../../../types';
import { usePermissionSets } from '../../../store/PermissionSets';
import { TextSpan } from '../../Atoms/Text';
import { PermissionSetConfigSection } from './PermissionSetConfigSection';
import { SetUserAssignments } from './SetUserAssignments';
import { SetTeamAssignments } from './SetTeamAssignments';

export interface PermissionSetDetailProps {
  permissionSet: PermissionSet;
  onBack: () => void;
}

export const PermissionSetDetail = ({ permissionSet, onBack }: PermissionSetDetailProps) => {
  const { permissionSets } = usePermissionSets();
  const current = permissionSets.find((set) => set.id === permissionSet.id) ?? permissionSet;

  return (
    <Stack
      spacing={4}
      data-cy="permission-set-detail">
      <button
        type="button"
        className="flex items-center gap-1 w-fit"
        data-cy="permission-set-detail-back"
        onClick={onBack}>
        <TextSpan
          color="grey12"
          size="sm14">
          ← Back to Permission Sets
        </TextSpan>
      </button>
      <PermissionSetConfigSection permissionSet={current} />
      <SetUserAssignments permissionSetId={current.id} />
      <SetTeamAssignments permissionSetId={current.id} />
    </Stack>
  );
};
